import { valueStoreFactory } from '../../../../services/utils/valueStoreFactory';

export const authenticationTypeStore = valueStoreFactory();
